import {z} from 'zod';
import {CopilotWidgetType, EntityTypeToRename} from '../copilot.enums';
import {entityToRenameSchema} from '../copilot.schemas';

function batchRenameWidgetSchema(entityType: EntityTypeToRename) {
  return z.object({
    type: z.literal(CopilotWidgetType.BatchRenameWidget),
    content: z.object({
      entityType: z.literal(entityType),
      entitiesToRename: z.array(entityToRenameSchema),
    }),
  });
}

export default batchRenameWidgetSchema;
